import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import home from '@/components/page/home'
import product from '@/components/page/product'
import secret from '@/components/page/secret'
import product2 from '@/components/page/product_inlet2'

import service from '@/components/page/service'
import service1 from '@/components/page/service_inlet1'
import service2 from '@/components/page/service_inlet2'
import service3 from '@/components/page/service_inlet3'
import service4 from '@/components/page/service_inlet4'
import service5 from '@/components/page/service_inlet5'
import service6 from '@/components/page/service_inlet6'
import service7 from '@/components/page/service_inlet7'
import service8 from '@/components/page/service_inlet8'



import news from '@/components/page/news'
import aboutUs from '@/components/page/aboutUs'
import newDetail from '@/components/page/newDetail'
import jobDetail from '@/components/page/jobDetail'
import join from '@/components/page/join'
import joinList from '@/components/page/joinList'

import phoneUserVal from '@/components/page/phone/phoneUserVal'
import phoneProduct from '@/components/page/phone/phoneProduct'
import phoneService from '@/components/page/phone/phoneService'
import phoneNews from '@/components/page/phone/phoneNews'
import phoneNewsDetail from '@/components/page/phone/phoneNewsDetail'
import phoneJoinUs from '@/components/page/phone/phoneJoinUs'
import phoneCloseCM from '@/components/page/phone/phoneCloseCM'

import more from '@/components/page/more'


Vue.use(Router)
const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      }
    }

  },
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      redirect:'/home',
      children: [
        {
          path: '/home',
          name: 'Home',
          component: home,
          meta:{
            title:'辰鳗科技_能源管理系统小鳗管家_创始人朱越洋',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/product',
          name: 'product',
          component: product,
          meta:{
            title:'关于辰鳗_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/product2',
          name: 'product2',
          component: product2,
          meta:{
            title:'关于辰鳗_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/service',
          name: 'service',
          component: service,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/brand',
          name: 'secret',
          component: secret,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/service1',
          name: 'service1',
          component: service1,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/service2',
          name: 'service2',
          component: service2,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/service3',
          name: 'service3',
          component: service3,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        // {
        //   path: '/service4',
        //   name: 'service4',
        //   component: service4,
        //   meta:{
        //     title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
        //     content:{
        //         keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
        //         description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
        //     },
        //   }
        // },
        // {
        //   path: '/service5',
        //   name: 'service5',
        //   component: service5,
        //   meta:{
        //     title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
        //     content:{
        //         keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
        //         description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
        //     },
        //   }
        // },
        {
          path: '/service6',
          name: 'service6',
          component: service6,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/service7',
          name: 'service7',
          component: service7,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/service8',
          name: 'service8',
          component: service8,
          meta:{
            title:'产品与服务_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统,小鳗管家智能云平台',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/news',
          name: 'news',
          component: news,
          meta:{
            title:'新闻中心_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
         {
          path: '/moreNews',
          name: 'more',
          component: more,
          meta:{
            title:'新闻中心_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: aboutUs,
          meta:{
            title:'关于辰鳗_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/newDetail/:id',
          name: 'newDetail',
          component: newDetail,
          props: true,
          meta:{
            // title:'新闻中心_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/jobDetail/:id',
          name: 'jobDetail',
          component: jobDetail,
          props: true,
          meta:{
            // title:'新闻中心_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/joinUs',
          name: 'join',
          component: join,
          props: true,
          meta:{
            title:'加入辰鳗_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/joinUs2',
          name: 'joinList',
          component: joinList,
          props: true,
          meta:{
            // title:'新闻中心_能源管理系统小鳗管家_创始人朱越洋【辰鳗科技】',
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneProduct',
          name: 'phoneProduct',
          component: phoneProduct,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneUserVal',
          name: 'phoneUserVal',
          component: phoneUserVal,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneService',
          name: 'phoneService',
          component: phoneService,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneNews',
          name: 'phoneNews',
          component: phoneNews,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneNewsDetail/:id',
          name: 'phoneNewsDetail',
          component: phoneNewsDetail,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneJoinUs',
          name: 'phoneJoinUs',
          component: phoneJoinUs,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
        {
          path: '/phoneCloseCM',
          name: 'phoneCloseCM',
          component: phoneCloseCM,
          props: true,
          meta:{
            content:{
                keywords:'辰鳗科技,朱越洋,小鳗管家,能源管理系统',
                description:'辰鳗科技致力于降低能源损耗，提供高效能源利用方案；为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务。',
            },
          }
        },
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js